import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1F2937] text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="space-y-3">
          <div className="text-2xl font-extrabold font-display text-white">HE<span className="text-[#E0243A]">LIUM</span></div>
          <div className="text-[#E0243A] text-xs tracking-[0.2em] font-semibold">HERZ DES KRANKENHAUSES</div>
          <p className="text-sm text-gray-400 leading-relaxed max-w-xs">Frisches Essen, Kaffee, Snacks und Catering – direkt dort, wo Menschen es brauchen.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Entdecken</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/standorte" className="hover:text-white">Standorte</Link></li>
            <li><Link to="/wochenmenue" className="hover:text-white">Wochenmenü</Link></li>
            <li><Link to="/angebote" className="hover:text-white">Angebote</Link></li>
            <li><Link to="/helium-vorteile" className="hover:text-white">Helium Club</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Service</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/veranstaltungen" className="hover:text-white">Veranstaltungen</Link></li>
            <li><Link to="/catering" className="hover:text-white">Catering anfragen</Link></li>
            <li><Link to="/kontakt" className="hover:text-white">Kontakt</Link></li>
            <li><Link to="/feedback" className="hover:text-white">Feedback</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Rechtliches</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/impressum" className="hover:text-white">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-white">Datenschutzerklärung</Link></li>
          </ul>
          <div className="mt-4 space-y-1 text-sm text-gray-400">
            <div className="flex items-center gap-2"><Mail className="w-4 h-4" /> info@helium-catering.de</div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} HELIUM Catering UG. Alle Rechte vorbehalten.
      </div>
    </footer>
  );
}
